import { ErreurApi, type Client } from '../api/client.js';
import type { Session } from '../api/contrat.js';
import { COULEURS, POLICE_SYSTEME } from './styles.js';

/**
 * Atterrissage du lien magique (portail mandant, héritier). Le jeton est opaque ; la page n’affiche ni lui ni aucune
 * donnée personnelle (UX-13). Côté client : 18 px, police système, une seule information à la fois.
 */
export type ResultatLien = { ok: true; session: Session } | { ok: false; message: string };

export type EtatLien = { etat: 'verification' } | { etat: 'erreur'; message: string };

export async function ouvrirLienMagique(client: Client, jeton: string): Promise<ResultatLien> {
  try {
    return { ok: true, session: await client.appeler<Session>('auth.lienMagique', { corps: { token: jeton } }) };
  } catch (e) {
    if (e instanceof ErreurApi) return { ok: false, message: e.messageUtilisateur };
    throw e;
  }
}

export function PageLienMagique({ etat }: { etat: EtatLien }) {
  return (
    <div
      data-page="lien-magique"
      style={{
        maxWidth: 560,
        margin: '0 auto',
        padding: 24,
        fontFamily: POLICE_SYSTEME,
        fontSize: 18,
        lineHeight: 1.5,
        color: COULEURS.marineFonce,
      }}
    >
      <h1 style={{ color: COULEURS.marine, fontSize: 28 }}>Votre espace succession</h1>
      {etat.etat === 'verification' ? (
        <p role="status">Ouverture de votre espace en cours. Quelques secondes suffisent.</p>
      ) : (
        <div role="alert">
          <p>{etat.message}</p>
          <p>Si vous avez besoin d’aide, répondez au dernier message reçu : le Cabinet MAAT vous renverra un nouveau lien.</p>
        </div>
      )}
      <p style={{ color: COULEURS.ardoise }}>Cabinet MAAT</p>
    </div>
  );
}
